import { render, staticRenderFns } from "./CommunityRulesComponent.vue?vue&type=template&id=6cd86914&"
import script from "./CommunityRulesComponent.vue?vue&type=script&lang=js&"
export * from "./CommunityRulesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports